<template>
  <div id="app">
    <nav-bar></nav-bar>
    <landing-page></landing-page>
    <nosotros></nosotros>
    <servicios></servicios>
    <flotilla></flotilla>
    <clientes></clientes>
    <cobertura></cobertura>
    <contacto></contacto>
  </div>
</template>

<script>
import NavBar from './components/Header.vue'
import LandingPage from './components/Landing.vue'
import Nosotros from './components/Nosotros.vue'
import Servicios from './components/Servicios.vue'
import flotilla from './components/flotilla.vue'
import clientes from './components/clientes.vue'
import cobertura from './components/cobertura.vue'
import contacto from './components/contacto.vue'



export default {
  name: 'app',
  components: {
    NavBar,
    LandingPage,
    Nosotros,
    Servicios,
    flotilla,
    clientes,
    cobertura,
    contacto
  }
}
</script>

<style lang="scss">
@import '~varmix';

	@font-face {
		font-family: bebas;
		src: url(~assets/fonts/BebasNeue.otf);
	}

	@font-face {
		font-family: mRegular;
		src: url(~assets/fonts/Montserrat-Regular.ttf);
	}
	@font-face {
		font-family: mBold;
		src: url(~assets/fonts/Montserrat-Bold.otf);
	}
  @font-face {
		font-family: mEbold;
		src: url(~assets/fonts/Montserrat-ExtraBold.otf);
	}

  @font-face {
		  font-family: 'Lato', sans-serif;

	}




  body{
    font-family: lato;
  }

  a.btn-default{
    font-family: lato;
    font-weight:700;
  }



</style>



// WEBPACK FOOTER //
// App.vue?37b16a06